module.exports = __webpack_public_path__ + "img/crustaces-en-ligne-boutrais-medium.c1fb7dfb.png";